// notificationContext.js
import React, { createContext, useReducer, useContext } from 'react';

const initialState = {
  newNotifications: 0,
};

const notificationsReducer = (state, action) => {
  switch (action.type) {
    case 'ADD_NOTIFICATION':
      return { ...state, newNotifications: state.newNotifications + 1 };
    case 'CLEAR_NOTIFICATIONS':
      return { ...state, newNotifications: 0 };
    case 'SET_NOTIFICATIONS':
      return { ...state, newNotifications: action.payload };
    default:
      return state;
  }
};

const NotificationsContext = createContext();

export const NotificationsProvider = ({ children }) => {
  const [state, dispatch] = useReducer(notificationsReducer, initialState);

  return (
      <NotificationsContext.Provider value={{ state, dispatch }}>
        {children}
      </NotificationsContext.Provider>
  );
};

export const useNotifications = () => {
  const context = useContext(NotificationsContext);
  if (!context) {
    throw new Error('useNotifications must be used within a NotificationsProvider');
  }
  return context;
};
